import { heroEquipment } from "../HeroEquipment";

export const krwaweSmoki = {
  heroes: {
    "Krwawy smok": {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 100,
      number: 1,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 6, 4, 4, 4, 2, 6, 1, 8],
        Maksymalna: [6, 8, 6, 7, 6, 4, 9, 4, 10],
      },
      rules: [
        "Anatema",
        "Berserk",
        "Dowodzenie",
        "Dowódca",
        "Głód krwi",
        "Łatwopalny",
        "Mistrz miecza",
        "Nieumarły",
        "Tempy",
        "Magia Krwi",
      ],
      exp: 20,
      skills: [0, 3, 4, 5],
    },
    Nekromanta: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 45,
      number: 1,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Animacja", "Mag (Dziedzina Nekromancji)"],
      exp: 8,
      skills: [0, 2, 5],
    },
    Gwardzista: {
      id: 2,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 50,
      number: 1,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 4, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Szermierz", "Żywa tarcza"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Giermek": {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 2,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Przyboczny", "Żywa tarcza"],
      exp: 0,
      skills: [0, 4, 5],
    },
    Szkielet: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 15,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 2, 1, 3],
        Maksymalna: [4, 2, 2, 3, 3, 1, 2, 1, 3],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Martwe zło",
        "Nieśmiertelny",
        "Nieumarły",
        "Rozmiar rzondzi",
      ],
    },
    Ghoul: {
      id: 5,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 40,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 0, 3, 4, 1, 3, 2, 6],
        Maksymalna: [5, 6, 0, 4, 4, 3, 6, 4, 8],
      },
      rules: ["Głód krwi", "Murołaz", "Ograniczony", "Sfora", "Strach"],
    },
    Wicht: {
      id: 6,
      startingEquipment: ["Miecz", "Średni", "Tarcza"],
      cost: 50,
      number: 3,
      equipmentList:
        heroEquipment["Nieumarły poczet Krwawego Smoka"].Stronnicy,
      type: "Stronnik",
      stats: {
        "Początkowa": [4,3,3,3,4,1,3,1,8],
        "Maksymalna": [5,6,6,4,4,3,6,4,9]
      },
      rules: ["Nieumarły", "Świadomy", "Zabójczy cios"],
    },
    Zombie: {
      id: 7,
      startingEquipment: ["Broń naturalna"],
      cost: 20,
      number: 7,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [3, 2, 0, 3, 3, 1, 1, 1, 2],
        Maksymalna: [3, 2, 0, 3, 3, 1, 1, 1, 2],
      },
      rules: [
        "Animacja",
        "Mięso armatnie",
        "Nieumarły",
        "Trudny do zabicia",
        "Uderza jako ostatni",
      ],
    },
    "Czarny rycerz": {
      id: 8,
      startingEquipment: [
        "Miecz",
        "Tarcza",
        "Nieumarły koń",
        "Siodło & uprząż",
      ],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Nieumarły poczet Krwawego Smoka"].Rycerz,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Nieumarły koń": [8, 2, 0, 3, "-", "-", 2, 1, 4],
      },
      rules: [
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Nieumarły",
        "Świadomy",
        "Zabójczy cios",
      ],
    },
    Graveir: {
      id: 9,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 0, 4, 4, 3, 2, 2, 6],
        Maksymalna: [6, 6, 0, 5, 5, 5, 6, 5, 8],
      },
      rules: ["Bycza szarża","Duży cel","Ghast","Głód krwi","Głód trzewi","Łuskowata skóra (5+)","Murołaz","Ograniczony","Przepastne trzewia","Stan niższy","Strach","Wielkolud","Zabójczy cios"],
    },

    Rydwan: {
      id: 10,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Czarna Karoca": ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Nieumarły koń": [8, 2, 0, 3, "-", "-", 2, 1, 4],
        "Nieumarły koń  ": [8, 2, 0, 3, "-", "-", 2, 1, 4],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
    Ścierwowóz: {
      id: 11,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Ścierwowóz: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Nieumarły koń": [8, 2, 0, 3, "-", "-", 2, 1, 4],
        "Nieumarły koń  ": [8, 2, 0, 3, "-", "-", 2, 1, 4],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan", "Strach", "Ścierwowóz"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Nieumarły poczet Krwawego Smoka",
  nature: "Praworządna",
  armyRules: ["Kontrolowanie ożywieńców", "Podatek", "Rozrzutność"],
  mercenaries: [
    "Czarownica",
    "Hiena cmentarna",
    "Łowca nagród",
    "Porywacz zwłok",
    "Rycerz najemny",
    "Skryba",
    "Szpieg",
    "Woźnica",
    "Złodziej",
    "Zwadźca",
  ],
};
